import OBGYNQuestionaireConnector from "../../Blocks/QuestionnaireModal/OBGYNQuestionaire/OBGYNQuestionaireConnector.jsx";


const OBGYNQuestions  = (props) =>{
        return(
            <OBGYNQuestionaireConnector 
                componentType={'obflow'}
                phone={props.props.doctor.phone}
                doctor={props.props.doctor}
                showTimeSlots= {props.state.showTimeSlots}
                setShowTimeSlots = {props.setShowTimeSlots}
                timesDrawer = {props.timesDrawer}
                hideOBGYNQuestions= {props.hideOBGYNQuestions}
            />
        )
    
}

export default OBGYNQuestions;